import React from 'react';
import type { Node } from 'react';
import type { User } from 'gwu';
import { Route } from 'react-router-dom';
import queryString from 'query-string';
import RedirectUtil from '../../util/redirect-util';

const ONBOARDING_PATH = '/onboarding';

type Props = {
  isAuthenticated: boolean,
  canAccess: (user: User) => boolean,
  userProfile: User,
  ssoUrl: string,
  component: Component
}

const PrivateRoute = ({ isAuthenticated = false, canAccess, userProfile, ssoUrl, component: Component, ...rest }: Props) => {
  const goToSsoUrl = () => {
    window.location = ssoUrl;
  };

  const renderComponent = (props): Node => {
    if (!isAuthenticated) {
      if (!ssoUrl) {
        return RedirectUtil.redirect('/login', props.location);
      }

      return goToSsoUrl();
    }

    if (canAccess !== undefined && !canAccess(userProfile.rights)) {
      return RedirectUtil.redirect('/forbidden');
    }

    const { pathname, search } = props.location;
    const { next } = queryString.parse(search);

    if (next && !['', '/', '/login'].includes(next)) {
      const nextClean = next === '//' ? '/' : next;
      return RedirectUtil.next(nextClean, props.location);
    }

    const { onboardingMode } = userProfile.preferences;
    const isOnnboardingMode = (onboardingMode === undefined || onboardingMode);
    if (isOnnboardingMode && pathname !== ONBOARDING_PATH) {
      return RedirectUtil.redirect(ONBOARDING_PATH, props.location);
    }
    else if (!isOnnboardingMode && pathname === ONBOARDING_PATH) {
      return RedirectUtil.redirect('/', props.location);
    }


    return (
      <Component {...props} />
    );
  };

  const render = props => renderComponent(props);

  return (
    <Route
      {...rest}
      render={render}
    />
  );
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/core/PrivateRoute.js